let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/spvLightNodes',
        name: 'spvLightNodes',
        component: resolve => require(['@/views/spvLightNodes/index'], resolve),
        meta: {
          title: 'SPV轻节点管理',
          breadLevel: 0,
          icon: 'icon-spv-light-nodes',
          auth: '5'
        }
      }
    ]
  }
]
export default routes
